import { render, staticRenderFns } from "./YA_ScrollComponent.vue?vue&type=template&id=33b58df7&scoped=true"
import script from "./YA_ScrollComponent.vue?vue&type=script&lang=js"
export * from "./YA_ScrollComponent.vue?vue&type=script&lang=js"
import style0 from "./YA_ScrollComponent.vue?vue&type=style&index=0&id=33b58df7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b58df7",
  null
  
)

export default component.exports